class SVGLoader {
    constructor(url) {
        this.svgUrl = url;
        this.svgLoader();
    }
    svgSuccess(e) {
        const oThis = e.target;
        if (oThis.status.toString() !== "404") {
            const div = document.createElement("div");
            div.className = "svg-loader-placeholder";
            div.innerHTML = oThis.responseText;
            div.style.display = "none";
            document.body.appendChild(div);
        }
    }
    svgError(e) {
        console.error("SVG Load Error", e);
    }
    svgLoader() {
        const xhr = new XMLHttpRequest();
        xhr.onload = this.svgSuccess.bind(this);
        xhr.onerror = this.svgError.bind(this);
        xhr.open("get", this.svgUrl, true);
        xhr.send();
    }
}
const SVGSpriteInit = {
    init() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const { path } = window.theme;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.SVG = new SVGLoader(`${path}/build/icons.svg`);
    },
};
export default SVGSpriteInit;
